export const calculatePopoverState = (
    containerElement: HTMLElement,
    popoverElement: HTMLElement,
    anchorElementClass: string,
): void => {
    const windowHeight = window.innerHeight;
    const parentRect = containerElement.parentElement.getBoundingClientRect();
    const anchorElement = containerElement.querySelector(anchorElementClass);
    const anchorRect = anchorElement.getBoundingClientRect();

    if (!popoverElement) {
        return;
    }

    const listRect = popoverElement.getBoundingClientRect();

    if (listRect.height + anchorRect.bottom >= windowHeight && anchorRect.top - listRect.height > 0) {
        popoverElement.style.top = '';
        popoverElement.style.bottom = `calc(${-anchorRect.top}px + var(--space-s)`;
    } else {
        popoverElement.style.top = `calc(${anchorRect.bottom}px + var(--space-s)`;
        popoverElement.style.bottom = '';
    }

    popoverElement.style.left = `${anchorRect.left}px`;
    popoverElement.style.width = `${parentRect.width}px`;
    popoverElement.style.visibility = 'visible'; // Try to prevent flicker
};
